query propstackTeams($companyId: ID!) {
  propstackTeams(companyId: $companyId) {
    id
    name
  }
}
